// Admin API helpers – all calls go through /api/*
// During CRA dev: proxy in package.json forwards these to Express on port 4000
// In production: Express itself serves the React build

const API_BASE = "";

function getToken() {
  return sessionStorage.getItem("vs_admin_token");
}

function setToken(token) {
  sessionStorage.setItem("vs_admin_token", token);
}

function clearToken() {
  sessionStorage.removeItem("vs_admin_token");
}

export async function apiLogin(username, password) {
  const res = await fetch(`${API_BASE}/api/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Login failed");
  setToken(data.token);
  return data;
}

export async function apiLogout() {
  try {
    await fetch(`${API_BASE}/api/logout`, {
      method: "POST",
      headers: { "x-admin-token": getToken() },
    });
  } finally {
    clearToken();
  }
}

export async function apiGetConfig() {
  const res = await fetch(`${API_BASE}/api/config`, {
    headers: { "x-admin-token": getToken() },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to fetch config");
  return data;
}

export async function apiSaveConfig(config) {
  const res = await fetch(`${API_BASE}/api/config`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "x-admin-token": getToken(),
    },
    body: JSON.stringify(config),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to save config");
  return data;
}

export async function apiListAssets() {
  const res = await fetch(`${API_BASE}/api/assets`, {
    headers: { "x-admin-token": getToken() },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to list assets");
  return data;
}

export async function apiUploadAsset(file) {
  const formData = new FormData();
  formData.append("image", file);
  const res = await fetch(`${API_BASE}/api/assets/upload`, {
    method: "POST",
    headers: { "x-admin-token": getToken() },
    body: formData,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Failed to upload image");
  return data;
}

export function isLoggedIn() {
  return !!getToken();
}
